import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";
import CloseIcon from "@mui/icons-material/Close";
import "./game.css";
import Header from "../components/Header";

function Sicbo() {
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    const [loading, setLoading] = useState(false);
    const [profile, setProfile] = useState(null);
    const [game, setGame] = useState(null);
    const [title, setTitle] = useState(null);
    const [isShow, setShow] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                if (profile !== res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch((err) => localStorage.removeItem("user"));
    }, []);

    function isMobileDevice() {
        if (window.innerWidth < 800) {
            return true;
        }
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {}).then((res) => {
            setProfile(res.data.data);
            localStorage.setItem("profile", JSON.stringify(res.data.data));
        });
    }, []);

    function launchGame(params) {
        if (!localStorage.getItem("profile")) {
            swal("Thông báo", "Vui lòng đăng nhập", "info");
            return;
        }
        if (loading === true) return;
        const form = {
            ...params,
            mobile: isMobileDevice() === true ? 1 : 0
        };
        setLoading(true);
        axios
            .post(`${process.env.REACT_APP_API_URL}/casino/launch`, form)
            .then((res) => {
                if (res.data.data.errMsg === "SUCCESS") {
                    window.open(res.data.data.gameUrl, "_blank");
                } else {
                    swal("Sảnh đang bảo trì", "Vui lòng chọn sảnh khác", "error");
                }
                setLoading(false);
            })
            .catch((err) => {
                swal("Thất bại", err.response?.data?.message !== "internal server error" ? err.response?.data?.message : "Đã có lỗi xảy ra", "error");
                setLoading(false);
            });
    }

    const [yoGame, setYoGame] = useState(false);
    const [yoPopup, setYoPopup] = useState(false);
    const [yoType, setYoType] = useState(1);
    const [yoMoney, setYoMoney] = useState(0);
    const [yoBalance, setYoBalance] = useState(0);

    const openYoGame = () => {
        if (profile === null) {
            return navigate("/login");
        }
        setLoading(true);
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/logingame`)
            .then((res) => {
                setYoGame(res.data.data);
                setYoBalance(res.data.data?.AccountInfo?.Balance);
                setYoPopup(true);
                setLoading(false);
            })
            .catch((err) => {
                swal("Thất bại", err.response?.data?.message !== "internal server error" ? err.response?.data?.message : "Đã xảy ra lỗi", "error");
                setLoading(false);
            });
    };

    const [isSubmitting, setIsSubmitting] = useState(false);

    const submitYoGame = async () => {
        if (profile === null) {
            return navigate("/login");
        }
        if (isSubmitting) {
            return swal("Thông báo", "Bạn thao tác quá nhanh", "warning");
        }
        setLoading(true);
        const transactionAmount = Number(String(yoMoney).replaceAll(".", "").replaceAll(",", ""));
        if (transactionAmount <= 0) {
            setLoading(false);
            return swal("Chú ý", "Vui lòng nhập số tiền hợp lệ", "warning");
        }
        const formData = {
            amount: transactionAmount,
            type: yoType
        };
        setIsSubmitting(true);
        axios
            .post(`${process.env.REACT_APP_API_URL}/auth/transfergame`, formData)
            .then((res) => {
                axios
                    .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
                    .then((resUser) => {
                        setProfile(resUser.data.data);
                        localStorage.setItem("profile", JSON.stringify(resUser.data.data));
                    })
                    .catch((err) => localStorage.removeItem("user"));
                    
                swal(yoType === 1 ? "Nạp tiền thành công" : "Rút tiền thành công", "", "success");
                setYoBalance(res.data.data.new_balance);
                setTimeout(() => {
                    setIsSubmitting(false);
                }, 3000);
                setLoading(false);
                setYoMoney("");
            })
            .catch((err) => {
                swal("Thất bại", err.response?.data?.message !== "internal server error" ? err.response?.data?.message : "Đã xảy ra lỗi", "error");
                setLoading(false);
                setIsSubmitting(false);
            });
    };

    return (
        <>
            <Header profile={profile} />

            <style>{`
                .minigame-page-wrapper {
                    background-color: #1b1e36;
                    min-height: 80vh;
                    font-family: Arial, sans-serif;
                    padding-bottom: 60px;
                }
                .minigame-container {
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 30px 20px;
                }
                
                /* Tiêu đề trang */
                .page-header-title {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    font-size: 22px;
                    font-weight: bold;
                    color: #0b7a65;
                    margin-bottom: 30px;
                    border-bottom: 2px solid #e5f9f3;
                    padding-bottom: 15px;
                }
                .page-header-title img {
                    width: 32px;
                    height: auto;
                    object-fit: contain;
                }

                /* Lưới Game */
                .minigame-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
                    gap: 25px;
                }
                .minigame-card {
                    background: #1b1e36;
                    border-radius: 12px;
                    overflow: hidden;
                    box-shadow: 0 4px 10px rgba(0,0,0,0.08);
                    transition: transform 0.3s, box-shadow 0.3s;
                    display: flex;
                    flex-direction: column;
                    cursor: pointer;
                    border: 1px solid #eee;
                }
                .minigame-card:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 8px 15px rgba(0,0,0,0.15);
                    border-color: #5df0b1;
                }
                .minigame-img-wrapper {
                    width: 100%;
                    height: 160px;
                    background: #232845; /* Nền nhạt để làm nổi bật logo */
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 15px;
                }
                .minigame-img-wrapper img {
                    max-height: 100%;
                    max-width: 100%;
                    object-fit: contain;
                    transition: transform 0.3s;
                }
                .minigame-card:hover .minigame-img-wrapper img {
                    transform: scale(1.08); /* Hiệu ứng phóng to logo nhẹ khi hover */
                }
                .minigame-info {
                    padding: 15px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 15px;
                }
                .minigame-title {
                    font-size: 16px;
                    font-weight: bold;
                    color: #0b7a65;
                    text-align: center;
                }
                .play-btn {
                    background: linear-gradient(90deg, #1fa270, #4bdc99);
                    width: 100%;
                    padding: 10px;
                    border-radius: 25px;
                    color: white;
                    font-weight: bold;
                    text-align: center;
                    border: none;
                    transition: 0.2s;
                }
                .play-btn:hover {
                    filter: brightness(1.1);
                    box-shadow: 0 4px 8px rgba(31, 162, 112, 0.4);
                }

                /* Popup ONWIN (YoGame) được thiết kế lại */
                .custom-popup-backdrop {
                    position: fixed;
                    top: 0; left: 0; right: 0; bottom: 0;
                    background: rgba(0, 0, 0, 0.6);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    z-index: 9999;
                    backdrop-filter: blur(3px);
                }
                .custom-popup-main {
                    background: #fff;
                    width: 90%;
                    max-width: 400px;
                    border-radius: 16px;
                    overflow: hidden;
                    box-shadow: 0 10px 30px rgba(0,0,0,0.3);
                    position: relative;
                }
                .custom-popup-header {
                    background: linear-gradient(90deg, #1fa270, #4bdc99);
                    color: #fff;
                    padding: 15px 20px;
                    font-size: 18px;
                    font-weight: bold;
                    text-align: center;
                    position: relative;
                }
                .custom-popup-close {
                    position: absolute;
                    right: 15px;
                    top: 50%;
                    transform: translateY(-50%);
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .custom-popup-content {
                    padding: 20px;
                }
                .yo-tabs {
                    display: flex;
                    background: #e5f9f3;
                    border-radius: 8px;
                    margin-bottom: 20px;
                    overflow: hidden;
                }
                .yo-tab {
                    flex: 1;
                    text-align: center;
                    padding: 12px;
                    font-weight: bold;
                    color: #1b684c;
                    cursor: pointer;
                    transition: 0.2s;
                }
                .yo-tab.active {
                    background: #1fa270;
                    color: #fff;
                }
                .yo-form-group {
                    display: flex;
                    flex-direction: column;
                    gap: 15px;
                    margin-bottom: 20px;
                }
                .yo-input {
                    width: 100%;
                    padding: 12px 15px;
                    border: 1px solid #7fe5c5;
                    border-radius: 8px;
                    font-size: 16px;
                    outline: none;
                    background: #f4fbf9;
                    box-sizing: border-box;
                }
                .yo-input:focus {
                    border-color: #1fa270;
                }
                .yo-btn-submit {
                    width: 100%;
                    padding: 12px;
                    border: none;
                    border-radius: 8px;
                    background: #1fa270;
                    color: #fff;
                    font-size: 16px;
                    font-weight: bold;
                    cursor: pointer;
                }
                .yo-btn-submit:hover {
                    background: #14503a;
                }
                .yo-balances {
                    background: #f9f9f9;
                    border-radius: 8px;
                    padding: 15px;
                    margin-bottom: 20px;
                    display: flex;
                    flex-direction: column;
                    gap: 10px;
                    font-size: 14px;
                    color: #555;
                }
                .yo-balances b {
                    color: #ff5050;
                    font-size: 16px;
                }
                .yo-btn-play {
                    width: 100%;
                    padding: 12px;
                    border: none;
                    border-radius: 25px;
                    background: linear-gradient(90deg, #ff8a00, #ffde00);
                    color: #333;
                    font-size: 16px;
                    font-weight: bold;
                    cursor: pointer;
                }

                @media (max-width: 768px) {
                    .minigame-grid {
                        grid-template-columns: repeat(2, 1fr);
                        gap: 15px;
                    }
                    .minigame-img-wrapper {
                        height: 120px;
                    }
                }
            `}</style>

            {loading === true ? (
                <div className="loading">
                    <div className="loader"></div>
                </div>
            ) : null}

            <div className="minigame-page-wrapper">
                <div className="minigame-container">
                    
                    <div className="page-header-title">
                        <img src={require("../../image/common/icon-taste.png")} alt="Trò Chơi" />
                        <span>Trò Chơi</span>
                    </div>

                    <div className="minigame-grid">
                        
                        <div className="minigame-card" onClick={() => navigate("/xs75s/lo2")}>
                            <div className="minigame-img-wrapper">
                                <img src={require("../../images/mb75s.png")} alt="Xổ số 75s" />
                            </div>
                            <div className="minigame-info">
                                <div className="minigame-title">Xổ số nhanh 75s</div>
                                <div className="play-btn">Vào trò chơi</div>
                            </div>
                        </div>

                        <div className="minigame-card" onClick={() => navigate("/xs120s/lo2")}>
                            <div className="minigame-img-wrapper">
                                <img src={require("../../images/st2p.png")} alt="Xổ số 120s" />
                            </div>
                            <div className="minigame-info">
                                <div className="minigame-title">Xổ số nhanh 120s</div>
                                <div className="play-btn">Vào trò chơi</div>
                            </div>
                        </div>

                        <div className="minigame-card" onClick={() => navigate("/xd45s")}>
                            <div className="minigame-img-wrapper">
                                <img src={require("../../images/xd45s.png")} alt="Xóc đĩa 45s" />
                            </div>
                            <div className="minigame-info">
                                <div className="minigame-title">Xóc đĩa 45s</div>
                                <div className="play-btn">Vào trò chơi</div>
                            </div>
                        </div>

                        <div className="minigame-card" onClick={() => navigate("/xd60s")}>
                            <div className="minigame-img-wrapper">
                                <img src={require("../../images/xd1p.png")} alt="Xóc đĩa 60s" />
                            </div>
                            <div className="minigame-info">
                                <div className="minigame-title">Xóc đĩa 60s</div>
                                <div className="play-btn">Vào trò chơi</div>
                            </div>
                        </div>

                        <div className="minigame-card" onClick={() => navigate("/tx45s")}>
                            <div className="minigame-img-wrapper">
                                <img src={require("../../images/tx45s.png")} alt="Tài xỉu 45s" />
                            </div>
                            <div className="minigame-info">
                                <div className="minigame-title">Tài xỉu 45s</div>
                                <div className="play-btn">Vào trò chơi</div>
                            </div>
                        </div>

                        <div className="minigame-card" onClick={() => navigate("/tx60s")}>
                            <div className="minigame-img-wrapper">
                                <img src={require("../../images/tx60s.png")} alt="Tài xỉu 60s" />
                            </div>
                            <div className="minigame-info">
                                <div className="minigame-title">Tài xỉu 60s</div>
                                <div className="play-btn">Vào trò chơi</div>
                            </div>
                        </div>

                  

                    </div>
                </div>
            </div>

            {/* Popup Quản lý Quỹ YoGame / ONWIN */}
            {yoPopup === true && yoGame && profile ? (
                <div className="custom-popup-backdrop">
                    <div className="custom-popup-main">
                        <div className="custom-popup-header">
                            Quản lý quỹ ONWIN
                            <div className="custom-popup-close" onClick={() => setYoPopup(false)}>
                                <CloseIcon sx={{ fontSize: "24px" }} />
                            </div>
                        </div>
                        <div className="custom-popup-content">
                            <div className="yo-tabs">
                                <div className={`yo-tab ${yoType === 1 ? "active" : ""}`} onClick={() => setYoType(1)}>Nạp tiền</div>
                                <div className={`yo-tab ${yoType === 2 ? "active" : ""}`} onClick={() => setYoType(2)}>Rút tiền</div>
                            </div>
                            
                            <div className="yo-form-group">
                                <input
                                    className="yo-input"
                                    type="text"
                                    value={yoMoney}
                                    onClick={() => setYoMoney("")}
                                    onChange={(e) => setYoMoney(Number(e.target.value.replaceAll(".", "").replaceAll(",", "")).toLocaleString("vi-VN"))}
                                    placeholder="Nhập số tiền..."
                                />
                                <button className="yo-btn-submit" onClick={submitYoGame}>
                                    Xác nhận {yoType === 1 ? "Nạp" : "Rút"}
                                </button>
                            </div>

                            <div className="yo-balances">
                                <div>Số dư ví ONWIN: <b>{yoBalance?.toLocaleString("vi-VN")} ₫</b></div>
                                <div>Số dư ví chính: <b>{profile?.money?.toLocaleString("vi-VN")} ₫</b></div>
                            </div>

                            <button className="yo-btn-play" onClick={() => (window.location.href = `https://game.ae888vip.bet?token=${yoGame?.Token}`)}>
                                VÀO CHƠI NGAY
                            </button>
                        </div>
                    </div>
                </div>
            ) : null}
        </>
    );
}

export default Sicbo;